<template>
	<div class="col-12">
		 <k-select v-if="!Boolean(Array.isArray(hiddenFields) && hiddenFields.includes('institucion'))"
	        title="Institución"
	        v-model="institucion"
	        :options="this.instituciones"
	        id="institucion_id_crear"
	        name="institucion_id"
	        required="true">
	    </k-select>
	    <k-select v-if="!Boolean(Array.isArray(hiddenFields) && hiddenFields.includes('regla_cobro'))"
	        title="Regla de cobro"
	        v-model="reglaCobro"
	        :options="reglasCobro"
	        id="regla_cobro_id_crear"
	        name="regla_cobro_id"
	        parent="institucion_id_crear"
	        required="true">
	    </k-select>
	    <k-input v-if="!Boolean(Array.isArray(hiddenFields) && hiddenFields.includes('nombre'))"
	        :required="true"
	        :expanded='true'
	        title="Nombre"
	        v-model="nombre"
	        name="nombre"
	        id="nombre">
	    </k-input>
	    
	    <div class="form-row">
	    	<div class="form-group col-xs-12 col-md-6 col-lg-6 component-input">
	    		<label for="parcialidad">
	    			Monto
	    		</label>
	    		<input type="text" name="monto" id="monto" v-model="monto" class="form-control" disabled>
	    	</div>
	    	<div class="form-group col-xs-12 col-md-6 col-lg-6 component-input">
	    		<label for="parcialidad">
	    			Parcialidades 
	    		</label>
	    		<input
	    		type="number"
	    		v-model="parcialidades"
	    		required="required"
	    		id="parcialidad"
	    		name="parcialidad"
	    		:disabled="!Boolean(monto)"
	    		class="form-control"
	    		@input="fraccionarMonto()">
	    	</div>            	
	    </div>    
	    <div class="form-row" v-for=" n in parseInt(parcialidades) || 0 " :key="n">
	    	<div class="form-group col-xs-12 col-md-6 col-lg-6 component-input mb-3">
	    		<label :for="`pago_${n}`">
	    			{{`Pago ${n}`}}
	    		</label>
	    		<input
	    		v-model="pagos[n]"
	    		type="number"
	    		required="required"
	    		:id="`pagos_${n}`"
	    		:name="`pagos[${n}]`"
	    		:disabled="!Boolean(monto)"
	    		class="form-control"
	    		step="0.01"
	    		min="1"
	    		:max="maxAmounts[n]"
	    		@input="onChangeAmount">          			
	    	</div>
	    	<div class="form-group col-xs-12 col-md-6 col-lg-6 component-input mb-3">
	    		<label :for="`vigencias_${n}`">
	    			Vigencia
	    		</label>
	    		<input
	    		v-model="vigencias[n]"
	    		type="date"
	    		required="required"
	    		:id="`vigencias_${n}`"
	    		:name="`vigencias[${n}]`"
	    		:disabled="!Boolean(pagos[n])"
	    		class="form-control">
	    	</div>
	    </div>
	</div>
</template>
<script>
import Axios from 'axios';
export default {
    props: [
        'instituciones',
        'pagoParcial',
        'hiddenFields',
        'saldo'
    ],
    data () {
        return {
            parcialidades : 1,
            institucion: null,
            reglaCobro: null,
            reglasCobro: [],
            dataEditar: {},
            maxAmounts: [],
            vigencias: [],
            pagos : [],
            nombre: '',
            monto: 0
        }
    },
    methods: {
        validarMonto (n) {
            let total = 0
            for (let i = 1; i < this.pagos.length; i++) {
                total += parseFloat((parseFloat(this.pagos[i]).toFixed(2)));
            }
            const restante = parseFloat(parseFloat(parseFloat(parseFloat(this.monto).toFixed(2)) - total).toFixed(2))
            if (restante < 0){
                this.pagos[n] = parseFloat(parseFloat(parseFloat(parseFloat(this.pagos[n]).toFixed(2)) + restante).toFixed(2))
            }
        },
        getReglasCobro () {
            axios.get(`/reglas-de-cobro/institucion/${this.institucion}`)
            .then(resp => {
                this.reglasCobro = Array.isArray(resp.data) ? resp.data : []
            })
            .catch( e => {
                this.reglasCobro = []
            })
        },
        getMonto () {
            axios.get(`/reglas-de-cobro/editar/${this.reglaCobro}`)
            .then(resp => {
                if (resp.data instanceof Object && resp.data.monto > 0 ) {
                    this.monto = resp.data.monto
                    if (!(this.dataEditar && this.dataEditar.editado)) {
                        this.fraccionarMonto()
                    }else{
                        this.dataEditar.editado = false
                    }

                }else{
                    this.monto = null
                }
            })
            .catch( e => {
                this.monto = null
            })
        },
        fraccionarMonto () {
            const montoParcial = parseFloat(this.monto)/parseInt(this.parcialidades)
            for (let i = 1; i <= parseInt(this.parcialidades); i++) {
                this.pagos[i] = parseFloat(parseFloat(montoParcial).toFixed(2))
                this.maxAmounts[i] = Math.ceil((this.monto/this.parcialidades)*100)/100
            }
        },
        onChangeAmount (evt) {
            const max = parseFloat(parseFloat(evt.target.max).toFixed(2))
            const pago = parseInt(evt.target.id.substr(5))
            const monto = parseFloat(parseFloat(evt.target.value).toFixed(2))
            if (monto > max){
                this.pagos[pago] = max
            } else if (pago === 0) {
                this.pagos[pago] = 1
            }
        },
        getMaxAmounts (pagos) {
            let total = 0
            for (let n = 1; n <= this.parcialidades; n++) {
                total += parseFloat(pagos[n] || 0);
            }
            if (this.parcialidades > 1){
                for (let i = 1; i <= this.parcialidades; i++) {
                    this.maxAmounts[i] = parseFloat(parseFloat(this.monto - ( total - parseFloat(parseFloat(pagos[i] || 0).toFixed(2)) )).toFixed(2));
                }
            } else {
                this.maxAmounts[1] = this.monto
            }
        }
    },
    watch: {
        pagos (val) {
            this.getMaxAmounts(val)
        },
        institucion (val) {
            if (val){
                this.getReglasCobro()
            }
        },
        reglaCobro (val){
            if (!this.pagoParcial){
                this.pagos = []
                this.parcialidades = 1
                this.monto = 0
            }
            if (val) {
                this.getMonto()
            }
        },
        pagoParcial (val) {
            this.dataEditar = {...val, editado: true}
            this.institucion = val.regla_cobro.institucion_id
            this.reglaCobro = val.regla_cobro_id
            this.parcialidades = val.parcialidades
            this.nombre = val.nombre
            for (let i = 0; i < val.parcialidades_cargos.length; i++) {
                this.pagos[i+1] = val.parcialidades_cargos[i].monto
                this.vigencias[i+1] = val.parcialidades_cargos[i].vigencias
            }
        },
        saldo( val ) {
            if ( parseFloat(val) > 0 ){
                this.monto = parseFloat(val)

            } 
        }
    }
}
</script>
